import { ColumnDef, DataGrid } from "@arelia-components/ui-atoms/data-grid";
import { useMemo } from "react";
import { MyContentSong } from "../models";

type Props = {
  data: MyContentSong[] | undefined;
};

export default function MyContentSongsPresenter({ data }: Props) {
  const columns: ColumnDef[] = useMemo(() => [
    { field: "artist", headerName: "Artist" },
    { field: "title", headerName: "Title" },
    { field: "songWriters", headerName: "Songwriters" },
    { field: "isrc", headerName: "ISRC" },
    { field: "distributors", headerName: "Distributor" },
    { field: "publishers", headerName: "Publisher" },
  ], []);

  return <DataGrid rows={data as MyContentSong[]} columns={columns} pageSize={10} />
}